"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantSettingsApi = exports.TenantSettingsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
// @ts-ignore
const models_4 = require("../models");
// @ts-ignore
const models_5 = require("../models");
// @ts-ignore
const models_6 = require("../models");
// @ts-ignore
const models_7 = require("../models");
// @ts-ignore
const models_8 = require("../models");
// @ts-ignore
const models_9 = require("../models");
// @ts-ignore
const models_10 = require("../models");
// @ts-ignore
const models_11 = require("../models");
// @ts-ignore
const models_12 = require("../models");
// @ts-ignore
const models_13 = require("../models");
// @ts-ignore
const models_14 = require("../models");
// @ts-ignore
const models_15 = require("../models");
// @ts-ignore
const models_16 = require("../models");
/**
 * TenantSettingsApi - axios parameter creator
 * @export
 */
const TenantSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {LeadTypeCreate} leadTypeCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadType: async (leadTypeCreate, options = {}) => {
            // verify required parameter 'leadTypeCreate' is not null or undefined
            (0, common_1.assertParamExists)('createLeadType', 'leadTypeCreate', leadTypeCreate);
            const localVarPath = `/api/lead-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadTypeCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PickIMaintenanceConfigEntityExcludeKeyofIMaintenanceConfigEntityMaintenanceConfigIdOrCreationDateOrClientIds} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceConfig: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createMaintenanceConfig', 'body', body);
            const localVarPath = `/api/maintenance-config/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PlanningItemSubTypeCreate} planningItemSubTypeCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanningItemSubType: async (planningItemSubTypeCreate, options = {}) => {
            // verify required parameter 'planningItemSubTypeCreate' is not null or undefined
            (0, common_1.assertParamExists)('createPlanningItemSubType', 'planningItemSubTypeCreate', planningItemSubTypeCreate);
            const localVarPath = `/api/planning-item-sub-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planningItemSubTypeCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkOrderChecklistCreate} workOrderChecklistCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderChecklist: async (workOrderChecklistCreate, options = {}) => {
            // verify required parameter 'workOrderChecklistCreate' is not null or undefined
            (0, common_1.assertParamExists)('createWorkOrderChecklist', 'workOrderChecklistCreate', workOrderChecklistCreate);
            const localVarPath = `/api/work-order-checklist/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistId
         * @param {WorkOrderChecklistCreate} workOrderChecklistCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderChecklistItem: async (workOrderChecklistId, workOrderChecklistCreate, options = {}) => {
            // verify required parameter 'workOrderChecklistId' is not null or undefined
            (0, common_1.assertParamExists)('createWorkOrderChecklistItem', 'workOrderChecklistId', workOrderChecklistId);
            // verify required parameter 'workOrderChecklistCreate' is not null or undefined
            (0, common_1.assertParamExists)('createWorkOrderChecklistItem', 'workOrderChecklistCreate', workOrderChecklistCreate);
            const localVarPath = `/api/work-order-checklist/{work_order_checklist_id}/item/create`
                .replace(`{${"work_order_checklist_id"}}`, encodeURIComponent(String(workOrderChecklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkOrderTypeCreate} workOrderTypeCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderType: async (workOrderTypeCreate, options = {}) => {
            // verify required parameter 'workOrderTypeCreate' is not null or undefined
            (0, common_1.assertParamExists)('createWorkOrderType', 'workOrderTypeCreate', workOrderTypeCreate);
            const localVarPath = `/api/work-order-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderTypeCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} leadTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadType: async (leadTypeId, options = {}) => {
            // verify required parameter 'leadTypeId' is not null or undefined
            (0, common_1.assertParamExists)('deleteLeadType', 'leadTypeId', leadTypeId);
            const localVarPath = `/api/lead-type/{lead_type_id}/delete`
                .replace(`{${"lead_type_id"}}`, encodeURIComponent(String(leadTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} maintenanceConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaintenanceConfig: async (maintenanceConfigId, options = {}) => {
            // verify required parameter 'maintenanceConfigId' is not null or undefined
            (0, common_1.assertParamExists)('deleteMaintenanceConfig', 'maintenanceConfigId', maintenanceConfigId);
            const localVarPath = `/api/maintenance-config/{maintenance_config_id}/delete`
                .replace(`{${"maintenance_config_id"}}`, encodeURIComponent(String(maintenanceConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemSubTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanningItemSubType: async (planningItemSubTypeId, options = {}) => {
            // verify required parameter 'planningItemSubTypeId' is not null or undefined
            (0, common_1.assertParamExists)('deletePlanningItemSubType', 'planningItemSubTypeId', planningItemSubTypeId);
            const localVarPath = `/api/planning-item-sub-type/{planning_item_sub_type_id}/delete`
                .replace(`{${"planning_item_sub_type_id"}}`, encodeURIComponent(String(planningItemSubTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderChecklist: async (workOrderChecklistId, options = {}) => {
            // verify required parameter 'workOrderChecklistId' is not null or undefined
            (0, common_1.assertParamExists)('deleteWorkOrderChecklist', 'workOrderChecklistId', workOrderChecklistId);
            const localVarPath = `/api/work-order-checklist/{work_order_checklist_id}/delete`
                .replace(`{${"work_order_checklist_id"}}`, encodeURIComponent(String(workOrderChecklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderChecklistItem: async (workOrderChecklistItemId, options = {}) => {
            // verify required parameter 'workOrderChecklistItemId' is not null or undefined
            (0, common_1.assertParamExists)('deleteWorkOrderChecklistItem', 'workOrderChecklistItemId', workOrderChecklistItemId);
            const localVarPath = `/api/work-order-checklist/item/{work_order_checklist_item_id}/delete`
                .replace(`{${"work_order_checklist_item_id"}}`, encodeURIComponent(String(workOrderChecklistItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderType: async (workOrderTypeId, options = {}) => {
            // verify required parameter 'workOrderTypeId' is not null or undefined
            (0, common_1.assertParamExists)('deleteWorkOrderType', 'workOrderTypeId', workOrderTypeId);
            const localVarPath = `/api/work-order-type/{work_order_type_id}/delete`
                .replace(`{${"work_order_type_id"}}`, encodeURIComponent(String(workOrderTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationSecretStatus: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/integration-secrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFeedbackSettings: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/lead-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailRecipientSettings: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/mail-recipients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailRecipientSettingsStatus: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/mail-recipients/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} maintenanceConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceConfigClients: async (maintenanceConfigId, options = {}) => {
            // verify required parameter 'maintenanceConfigId' is not null or undefined
            (0, common_1.assertParamExists)('getMaintenanceConfigClients', 'maintenanceConfigId', maintenanceConfigId);
            const localVarPath = `/api/maintenance-config/{maintenance_config_id}/clients`
                .replace(`{${"maintenance_config_id"}}`, encodeURIComponent(String(maintenanceConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovetexAutoSendSettings: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/movetex-auto-send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewClientDefaults: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/new-client-defaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteMailSettings: async (options = {}) => {
            const localVarPath = `/api/tenant-settings/quote-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaintenanceConfigs: async (options = {}) => {
            const localVarPath = `/api/maintenance-config/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LeadTypeReorder} leadTypeReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLeadTypes: async (leadTypeReorder, options = {}) => {
            // verify required parameter 'leadTypeReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderLeadTypes', 'leadTypeReorder', leadTypeReorder);
            const localVarPath = `/api/lead-type/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadTypeReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PlanningItemSubTypeReorder} planningItemSubTypeReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderPlanningItemSubTypes: async (planningItemSubTypeReorder, options = {}) => {
            // verify required parameter 'planningItemSubTypeReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderPlanningItemSubTypes', 'planningItemSubTypeReorder', planningItemSubTypeReorder);
            const localVarPath = `/api/planning-item-sub-type/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planningItemSubTypeReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistId
         * @param {WorkOrderChecklistReorder} workOrderChecklistReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWorkOrderChecklistItems: async (workOrderChecklistId, workOrderChecklistReorder, options = {}) => {
            // verify required parameter 'workOrderChecklistId' is not null or undefined
            (0, common_1.assertParamExists)('reorderWorkOrderChecklistItems', 'workOrderChecklistId', workOrderChecklistId);
            // verify required parameter 'workOrderChecklistReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderWorkOrderChecklistItems', 'workOrderChecklistReorder', workOrderChecklistReorder);
            const localVarPath = `/api/work-order-checklist/{work_order_checklist_id}/item/reorder`
                .replace(`{${"work_order_checklist_id"}}`, encodeURIComponent(String(workOrderChecklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkOrderChecklistReorder} workOrderChecklistReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWorkOrderChecklists: async (workOrderChecklistReorder, options = {}) => {
            // verify required parameter 'workOrderChecklistReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderWorkOrderChecklists', 'workOrderChecklistReorder', workOrderChecklistReorder);
            const localVarPath = `/api/work-order-checklist/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WorkOrderTypeReorder} workOrderTypeReorder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWorkOrderTypes: async (workOrderTypeReorder, options = {}) => {
            // verify required parameter 'workOrderTypeReorder' is not null or undefined
            (0, common_1.assertParamExists)('reorderWorkOrderTypes', 'workOrderTypeReorder', workOrderTypeReorder);
            const localVarPath = `/api/work-order-type/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderTypeReorder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} leadFeedbackId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendLeadFeedback: async (leadFeedbackId, options = {}) => {
            // verify required parameter 'leadFeedbackId' is not null or undefined
            (0, common_1.assertParamExists)('resendLeadFeedback', 'leadFeedbackId', leadFeedbackId);
            const localVarPath = `/api/lead-feedback/{lead_feedback_id}/resend`
                .replace(`{${"lead_feedback_id"}}`, encodeURIComponent(String(leadFeedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IIntegrationSecretUpdate} iIntegrationSecretUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIntegrationSecret: async (iIntegrationSecretUpdate, options = {}) => {
            // verify required parameter 'iIntegrationSecretUpdate' is not null or undefined
            (0, common_1.assertParamExists)('setIntegrationSecret', 'iIntegrationSecretUpdate', iIntegrationSecretUpdate);
            const localVarPath = `/api/tenant-settings/integration-secrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iIntegrationSecretUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} maintenanceConfigId
         * @param {InlineObject8} inlineObject8
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMaintenanceConfigClients: async (maintenanceConfigId, inlineObject8, options = {}) => {
            // verify required parameter 'maintenanceConfigId' is not null or undefined
            (0, common_1.assertParamExists)('setMaintenanceConfigClients', 'maintenanceConfigId', maintenanceConfigId);
            // verify required parameter 'inlineObject8' is not null or undefined
            (0, common_1.assertParamExists)('setMaintenanceConfigClients', 'inlineObject8', inlineObject8);
            const localVarPath = `/api/maintenance-config/{maintenance_config_id}/clients`
                .replace(`{${"maintenance_config_id"}}`, encodeURIComponent(String(maintenanceConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject8, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sweepLeadFeedback: async (options = {}) => {
            const localVarPath = `/api/lead-feedback/sweep`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ILeadFeedbackSettings} iLeadFeedbackSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadFeedbackSettings: async (iLeadFeedbackSettings, options = {}) => {
            // verify required parameter 'iLeadFeedbackSettings' is not null or undefined
            (0, common_1.assertParamExists)('updateLeadFeedbackSettings', 'iLeadFeedbackSettings', iLeadFeedbackSettings);
            const localVarPath = `/api/tenant-settings/lead-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iLeadFeedbackSettings, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} leadTypeId
         * @param {LeadTypeUpdate} leadTypeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadType: async (leadTypeId, leadTypeUpdate, options = {}) => {
            // verify required parameter 'leadTypeId' is not null or undefined
            (0, common_1.assertParamExists)('updateLeadType', 'leadTypeId', leadTypeId);
            // verify required parameter 'leadTypeUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updateLeadType', 'leadTypeUpdate', leadTypeUpdate);
            const localVarPath = `/api/lead-type/{lead_type_id}/update`
                .replace(`{${"lead_type_id"}}`, encodeURIComponent(String(leadTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(leadTypeUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IMailRecipientSettings} iMailRecipientSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMailRecipientSettings: async (iMailRecipientSettings, options = {}) => {
            // verify required parameter 'iMailRecipientSettings' is not null or undefined
            (0, common_1.assertParamExists)('updateMailRecipientSettings', 'iMailRecipientSettings', iMailRecipientSettings);
            const localVarPath = `/api/tenant-settings/mail-recipients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iMailRecipientSettings, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} maintenanceConfigId
         * @param {PickIMaintenanceConfigEntityExcludeKeyofIMaintenanceConfigEntityMaintenanceConfigIdOrCreationDateOrClientIds} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceConfig: async (maintenanceConfigId, body, options = {}) => {
            // verify required parameter 'maintenanceConfigId' is not null or undefined
            (0, common_1.assertParamExists)('updateMaintenanceConfig', 'maintenanceConfigId', maintenanceConfigId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('updateMaintenanceConfig', 'body', body);
            const localVarPath = `/api/maintenance-config/{maintenance_config_id}/update`
                .replace(`{${"maintenance_config_id"}}`, encodeURIComponent(String(maintenanceConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IMovetexAutoSendSettings} iMovetexAutoSendSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMovetexAutoSendSettings: async (iMovetexAutoSendSettings, options = {}) => {
            // verify required parameter 'iMovetexAutoSendSettings' is not null or undefined
            (0, common_1.assertParamExists)('updateMovetexAutoSendSettings', 'iMovetexAutoSendSettings', iMovetexAutoSendSettings);
            const localVarPath = `/api/tenant-settings/movetex-auto-send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iMovetexAutoSendSettings, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {INewClientDefaults} iNewClientDefaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNewClientDefaults: async (iNewClientDefaults, options = {}) => {
            // verify required parameter 'iNewClientDefaults' is not null or undefined
            (0, common_1.assertParamExists)('updateNewClientDefaults', 'iNewClientDefaults', iNewClientDefaults);
            const localVarPath = `/api/tenant-settings/new-client-defaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iNewClientDefaults, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemSubTypeId
         * @param {PlanningItemSubTypeUpdate} planningItemSubTypeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItemSubType: async (planningItemSubTypeId, planningItemSubTypeUpdate, options = {}) => {
            // verify required parameter 'planningItemSubTypeId' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemSubType', 'planningItemSubTypeId', planningItemSubTypeId);
            // verify required parameter 'planningItemSubTypeUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemSubType', 'planningItemSubTypeUpdate', planningItemSubTypeUpdate);
            const localVarPath = `/api/planning-item-sub-type/{planning_item_sub_type_id}/update`
                .replace(`{${"planning_item_sub_type_id"}}`, encodeURIComponent(String(planningItemSubTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planningItemSubTypeUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IQuoteMailSettings} iQuoteMailSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuoteMailSettings: async (iQuoteMailSettings, options = {}) => {
            // verify required parameter 'iQuoteMailSettings' is not null or undefined
            (0, common_1.assertParamExists)('updateQuoteMailSettings', 'iQuoteMailSettings', iQuoteMailSettings);
            const localVarPath = `/api/tenant-settings/quote-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iQuoteMailSettings, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistId
         * @param {WorkOrderChecklistUpdate} workOrderChecklistUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderChecklist: async (workOrderChecklistId, workOrderChecklistUpdate, options = {}) => {
            // verify required parameter 'workOrderChecklistId' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderChecklist', 'workOrderChecklistId', workOrderChecklistId);
            // verify required parameter 'workOrderChecklistUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderChecklist', 'workOrderChecklistUpdate', workOrderChecklistUpdate);
            const localVarPath = `/api/work-order-checklist/{work_order_checklist_id}/update`
                .replace(`{${"work_order_checklist_id"}}`, encodeURIComponent(String(workOrderChecklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderChecklistItemId
         * @param {WorkOrderChecklistUpdate} workOrderChecklistUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderChecklistItem: async (workOrderChecklistItemId, workOrderChecklistUpdate, options = {}) => {
            // verify required parameter 'workOrderChecklistItemId' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderChecklistItem', 'workOrderChecklistItemId', workOrderChecklistItemId);
            // verify required parameter 'workOrderChecklistUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderChecklistItem', 'workOrderChecklistUpdate', workOrderChecklistUpdate);
            const localVarPath = `/api/work-order-checklist/item/{work_order_checklist_item_id}/update`
                .replace(`{${"work_order_checklist_item_id"}}`, encodeURIComponent(String(workOrderChecklistItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderChecklistUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderTypeId
         * @param {WorkOrderTypeUpdate} workOrderTypeUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderType: async (workOrderTypeId, workOrderTypeUpdate, options = {}) => {
            // verify required parameter 'workOrderTypeId' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderType', 'workOrderTypeId', workOrderTypeId);
            // verify required parameter 'workOrderTypeUpdate' is not null or undefined
            (0, common_1.assertParamExists)('updateWorkOrderType', 'workOrderTypeUpdate', workOrderTypeUpdate);
            const localVarPath = `/api/work-order-type/{work_order_type_id}/update`
                .replace(`{${"work_order_type_id"}}`, encodeURIComponent(String(workOrderTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workOrderTypeUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TenantSettingsApiAxiosParamCreator = TenantSettingsApiAxiosParamCreator;
/**
 * TenantSettingsApi -
 */
var TenantSettingsApi;
(function (TenantSettingsApi) {
    /**
     *
     * @param {LeadTypeCreate} leadTypeCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-type/create
     */
    async function createLeadType(leadTypeCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createLeadType(leadTypeCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseILeadTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createLeadType = createLeadType;
    /**
     *
     * @param {PickIMaintenanceConfigEntityExcludeKeyofIMaintenanceConfigEntityMaintenanceConfigIdOrCreationDateOrClientIds} body
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/create
     */
    async function createMaintenanceConfig(body, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createMaintenanceConfig(body, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_7.parseIMaintenanceConfigEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createMaintenanceConfig = createMaintenanceConfig;
    /**
     *
     * @param {PlanningItemSubTypeCreate} planningItemSubTypeCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/planning-item-sub-type/create
     */
    async function createPlanningItemSubType(planningItemSubTypeCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanningItemSubType(planningItemSubTypeCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_10.parseIPlanningItemSubTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createPlanningItemSubType = createPlanningItemSubType;
    /**
     *
     * @param {WorkOrderChecklistCreate} workOrderChecklistCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/create
     */
    async function createWorkOrderChecklist(workOrderChecklistCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderChecklist(workOrderChecklistCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_12.parseIWorkOrderChecklistEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createWorkOrderChecklist = createWorkOrderChecklist;
    /**
     *
     * @param {number} workOrderChecklistId
     * @param {WorkOrderChecklistCreate} workOrderChecklistCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/{work_order_checklist_id}/item/create
     */
    async function createWorkOrderChecklistItem(workOrderChecklistId, workOrderChecklistCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderChecklistItem(workOrderChecklistId, workOrderChecklistCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_13.parseIWorkOrderChecklistItemEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createWorkOrderChecklistItem = createWorkOrderChecklistItem;
    /**
     *
     * @param {WorkOrderTypeCreate} workOrderTypeCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-type/create
     */
    async function createWorkOrderType(workOrderTypeCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderType(workOrderTypeCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_14.parseIWorkOrderTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.createWorkOrderType = createWorkOrderType;
    /**
     *
     * @param {number} leadTypeId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-type/{lead_type_id}/delete
     */
    async function deleteLeadType(leadTypeId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLeadType(leadTypeId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deleteLeadType = deleteLeadType;
    /**
     *
     * @param {number} maintenanceConfigId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/{maintenance_config_id}/delete
     */
    async function deleteMaintenanceConfig(maintenanceConfigId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMaintenanceConfig(maintenanceConfigId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deleteMaintenanceConfig = deleteMaintenanceConfig;
    /**
     *
     * @param {number} planningItemSubTypeId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/planning-item-sub-type/{planning_item_sub_type_id}/delete
     */
    async function deletePlanningItemSubType(planningItemSubTypeId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanningItemSubType(planningItemSubTypeId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deletePlanningItemSubType = deletePlanningItemSubType;
    /**
     *
     * @param {number} workOrderChecklistId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/{work_order_checklist_id}/delete
     */
    async function deleteWorkOrderChecklist(workOrderChecklistId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkOrderChecklist(workOrderChecklistId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deleteWorkOrderChecklist = deleteWorkOrderChecklist;
    /**
     *
     * @param {number} workOrderChecklistItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/item/{work_order_checklist_item_id}/delete
     */
    async function deleteWorkOrderChecklistItem(workOrderChecklistItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkOrderChecklistItem(workOrderChecklistItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deleteWorkOrderChecklistItem = deleteWorkOrderChecklistItem;
    /**
     *
     * @param {number} workOrderTypeId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-type/{work_order_type_id}/delete
     */
    async function deleteWorkOrderType(workOrderTypeId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkOrderType(workOrderTypeId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.deleteWorkOrderType = deleteWorkOrderType;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/integration-secrets
     */
    async function getIntegrationSecretStatus(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationSecretStatus(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseIIntegrationSecretStatus)(x));
            return res;
        });
    }
    TenantSettingsApi.getIntegrationSecretStatus = getIntegrationSecretStatus;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/lead-feedback
     */
    async function getLeadFeedbackSettings(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadFeedbackSettings(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseILeadFeedbackSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getLeadFeedbackSettings = getLeadFeedbackSettings;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/mail-recipients
     */
    async function getMailRecipientSettings(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getMailRecipientSettings(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_5.parseIMailRecipientSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getMailRecipientSettings = getMailRecipientSettings;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/mail-recipients/status
     */
    async function getMailRecipientSettingsStatus(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getMailRecipientSettingsStatus(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_6.parseIMailRecipientSettingsStatus)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getMailRecipientSettingsStatus = getMailRecipientSettingsStatus;
    /**
     *
     * @param {number} maintenanceConfigId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/{maintenance_config_id}/clients
     */
    async function getMaintenanceConfigClients(maintenanceConfigId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceConfigClients(maintenanceConfigId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_15.parseInlineResponse20011)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getMaintenanceConfigClients = getMaintenanceConfigClients;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/movetex-auto-send
     */
    async function getMovetexAutoSendSettings(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getMovetexAutoSendSettings(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_8.parseIMovetexAutoSendSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getMovetexAutoSendSettings = getMovetexAutoSendSettings;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/new-client-defaults
     */
    async function getNewClientDefaults(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getNewClientDefaults(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_9.parseINewClientDefaults)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getNewClientDefaults = getNewClientDefaults;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/quote-mail
     */
    async function getQuoteMailSettings(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteMailSettings(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_11.parseIQuoteMailSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.getQuoteMailSettings = getQuoteMailSettings;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/list
     */
    async function listMaintenanceConfigs(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listMaintenanceConfigs(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_7.parseIMaintenanceConfigEntity)(x));
            return res;
        });
    }
    TenantSettingsApi.listMaintenanceConfigs = listMaintenanceConfigs;
    /**
     *
     * @param {LeadTypeReorder} leadTypeReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-type/reorder
     */
    async function reorderLeadTypes(leadTypeReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderLeadTypes(leadTypeReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_4.parseILeadTypeEntity)(x));
            return res;
        });
    }
    TenantSettingsApi.reorderLeadTypes = reorderLeadTypes;
    /**
     *
     * @param {PlanningItemSubTypeReorder} planningItemSubTypeReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/planning-item-sub-type/reorder
     */
    async function reorderPlanningItemSubTypes(planningItemSubTypeReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderPlanningItemSubTypes(planningItemSubTypeReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_10.parseIPlanningItemSubTypeEntity)(x));
            return res;
        });
    }
    TenantSettingsApi.reorderPlanningItemSubTypes = reorderPlanningItemSubTypes;
    /**
     *
     * @param {number} workOrderChecklistId
     * @param {WorkOrderChecklistReorder} workOrderChecklistReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/{work_order_checklist_id}/item/reorder
     */
    async function reorderWorkOrderChecklistItems(workOrderChecklistId, workOrderChecklistReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWorkOrderChecklistItems(workOrderChecklistId, workOrderChecklistReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_12.parseIWorkOrderChecklistEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.reorderWorkOrderChecklistItems = reorderWorkOrderChecklistItems;
    /**
     *
     * @param {WorkOrderChecklistReorder} workOrderChecklistReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/reorder
     */
    async function reorderWorkOrderChecklists(workOrderChecklistReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWorkOrderChecklists(workOrderChecklistReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_12.parseIWorkOrderChecklistEntity)(x));
            return res;
        });
    }
    TenantSettingsApi.reorderWorkOrderChecklists = reorderWorkOrderChecklists;
    /**
     *
     * @param {WorkOrderTypeReorder} workOrderTypeReorder
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-type/reorder
     */
    async function reorderWorkOrderTypes(workOrderTypeReorder, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWorkOrderTypes(workOrderTypeReorder, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_14.parseIWorkOrderTypeEntity)(x));
            return res;
        });
    }
    TenantSettingsApi.reorderWorkOrderTypes = reorderWorkOrderTypes;
    /**
     *
     * @param {number} leadFeedbackId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-feedback/{lead_feedback_id}/resend
     */
    async function resendLeadFeedback(leadFeedbackId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.resendLeadFeedback(leadFeedbackId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseILeadFeedbackEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.resendLeadFeedback = resendLeadFeedback;
    /**
     *
     * @param {IIntegrationSecretUpdate} iIntegrationSecretUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/integration-secrets
     */
    async function setIntegrationSecret(iIntegrationSecretUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.setIntegrationSecret(iIntegrationSecretUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIIntegrationSecretStatus)(res.data);
            return res;
        });
    }
    TenantSettingsApi.setIntegrationSecret = setIntegrationSecret;
    /**
     *
     * @param {number} maintenanceConfigId
     * @param {InlineObject8} inlineObject8
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/{maintenance_config_id}/clients
     */
    async function setMaintenanceConfigClients(maintenanceConfigId, inlineObject8, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.setMaintenanceConfigClients(maintenanceConfigId, inlineObject8, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    TenantSettingsApi.setMaintenanceConfigClients = setMaintenanceConfigClients;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-feedback/sweep
     */
    async function sweepLeadFeedback(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.sweepLeadFeedback(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_16.parseInlineResponse2006)(res.data);
            return res;
        });
    }
    TenantSettingsApi.sweepLeadFeedback = sweepLeadFeedback;
    /**
     *
     * @param {ILeadFeedbackSettings} iLeadFeedbackSettings
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/lead-feedback
     */
    async function updateLeadFeedbackSettings(iLeadFeedbackSettings, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateLeadFeedbackSettings(iLeadFeedbackSettings, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseILeadFeedbackSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateLeadFeedbackSettings = updateLeadFeedbackSettings;
    /**
     *
     * @param {number} leadTypeId
     * @param {LeadTypeUpdate} leadTypeUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/lead-type/{lead_type_id}/update
     */
    async function updateLeadType(leadTypeId, leadTypeUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateLeadType(leadTypeId, leadTypeUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseILeadTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateLeadType = updateLeadType;
    /**
     *
     * @param {IMailRecipientSettings} iMailRecipientSettings
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/mail-recipients
     */
    async function updateMailRecipientSettings(iMailRecipientSettings, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateMailRecipientSettings(iMailRecipientSettings, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_5.parseIMailRecipientSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateMailRecipientSettings = updateMailRecipientSettings;
    /**
     *
     * @param {number} maintenanceConfigId
     * @param {PickIMaintenanceConfigEntityExcludeKeyofIMaintenanceConfigEntityMaintenanceConfigIdOrCreationDateOrClientIds} body
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/maintenance-config/{maintenance_config_id}/update
     */
    async function updateMaintenanceConfig(maintenanceConfigId, body, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaintenanceConfig(maintenanceConfigId, body, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_7.parseIMaintenanceConfigEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateMaintenanceConfig = updateMaintenanceConfig;
    /**
     *
     * @param {IMovetexAutoSendSettings} iMovetexAutoSendSettings
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/movetex-auto-send
     */
    async function updateMovetexAutoSendSettings(iMovetexAutoSendSettings, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateMovetexAutoSendSettings(iMovetexAutoSendSettings, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_8.parseIMovetexAutoSendSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateMovetexAutoSendSettings = updateMovetexAutoSendSettings;
    /**
     *
     * @param {INewClientDefaults} iNewClientDefaults
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/new-client-defaults
     */
    async function updateNewClientDefaults(iNewClientDefaults, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateNewClientDefaults(iNewClientDefaults, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_9.parseINewClientDefaults)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateNewClientDefaults = updateNewClientDefaults;
    /**
     *
     * @param {number} planningItemSubTypeId
     * @param {PlanningItemSubTypeUpdate} planningItemSubTypeUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/planning-item-sub-type/{planning_item_sub_type_id}/update
     */
    async function updatePlanningItemSubType(planningItemSubTypeId, planningItemSubTypeUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItemSubType(planningItemSubTypeId, planningItemSubTypeUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_10.parseIPlanningItemSubTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updatePlanningItemSubType = updatePlanningItemSubType;
    /**
     *
     * @param {IQuoteMailSettings} iQuoteMailSettings
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/tenant-settings/quote-mail
     */
    async function updateQuoteMailSettings(iQuoteMailSettings, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuoteMailSettings(iQuoteMailSettings, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_11.parseIQuoteMailSettings)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateQuoteMailSettings = updateQuoteMailSettings;
    /**
     *
     * @param {number} workOrderChecklistId
     * @param {WorkOrderChecklistUpdate} workOrderChecklistUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/{work_order_checklist_id}/update
     */
    async function updateWorkOrderChecklist(workOrderChecklistId, workOrderChecklistUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderChecklist(workOrderChecklistId, workOrderChecklistUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_12.parseIWorkOrderChecklistEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateWorkOrderChecklist = updateWorkOrderChecklist;
    /**
     *
     * @param {number} workOrderChecklistItemId
     * @param {WorkOrderChecklistUpdate} workOrderChecklistUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-checklist/item/{work_order_checklist_item_id}/update
     */
    async function updateWorkOrderChecklistItem(workOrderChecklistItemId, workOrderChecklistUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderChecklistItem(workOrderChecklistItemId, workOrderChecklistUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_13.parseIWorkOrderChecklistItemEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateWorkOrderChecklistItem = updateWorkOrderChecklistItem;
    /**
     *
     * @param {number} workOrderTypeId
     * @param {WorkOrderTypeUpdate} workOrderTypeUpdate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof TenantSettingsApi
     * url /api/work-order-type/{work_order_type_id}/update
     */
    async function updateWorkOrderType(workOrderTypeId, workOrderTypeUpdate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.TenantSettingsApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderType(workOrderTypeId, workOrderTypeUpdate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_14.parseIWorkOrderTypeEntity)(res.data);
            return res;
        });
    }
    TenantSettingsApi.updateWorkOrderType = updateWorkOrderType;
})(TenantSettingsApi || (exports.TenantSettingsApi = TenantSettingsApi = {}));
